<template>
<div>

<!-- Modal MESSAGE -->  
<modalMessage ref="msgModal"/>

<!-- Modal CONFIRM -->
<modalConfirm ref="confirmModal" />


<button v-if="btnBack" @click="$emit('back')"  class="btn btn-block btn-secondary mt-1  mb-1">
          <i style="color:yellow" class="fas fa-reply  mr-2" aria-hidden="true"></i>
          RITORNA A REGISTRAZIONE VARIANTI
</button>

<div class="jumbotron">
<document-header class="text-center"  v-bind:doc="doc" ></document-header>

<h4 class="text-center">
          <i class="fas fa-calculator mr-2" aria-hidden="true"></i>
          INSERIMENTO/MODIFICA PREZZO DI ACQUISTO,SCONTO,IVA E PREZZO DI VENDITA PRODOTTO
        </h4>
<product-info class="mt-1 ml-4" v-bind:productId="localProduct.productId"></product-info>   

<form class="ml-4" v-on:submit.prevent="submit()">

<div class="form-row align-items-center">  
    <div class="col-auto">

      <label for="input1"><strong>PREZZO DI ACQUISTO</strong></label>
          <div class="input-group mb-2">
              <div class="input-group-prepend">
              <div class="input-group-text euro1">€</div>
              </div>  
              <input step="0.01" name="inputPrezzo"  v-focus @input="setCostPrice()" required  id="price1" class="form-control"   type="number" v-model="prices.price1" v-bind:placeholder="'Prezzo di acquisto'">                  
          </div>          

    </div>
    
      <div v-if="inputSconto.length==0" class="col-auto">
        <button type="button" @click="add()" class="btn btn-link"><strong>INSERISCI SCONTO</strong></button>
      </div>
      <div 

        class="col-auto "
        v-for="(item,index) in inputSconto"
        :key="item.id"
      >
        <input-sconto
          ref="scontoInputs"
          v-model   = "item.discount"
          :label    = "item.label"
          :min      = "0"
          :max      = "100"
          @add      = "add()"
          :show-add = "index === inputSconto.length - 1 && inputSconto.length < 3"
        />
        
      </div>
    
      <div class="col-auto ">
        <label for="inputVat"><strong>ALIQUOTA IVA</strong></label>
        <div class="input-group mb-2">
                <div class="input-group-prepend">
                <div class="input-group-text perc">%</div>
                </div>  
          <input required type="number" class="form-control" placeholder="" v-model="prices.vat">
        </div>
      </div> 
    
      <div class="col-auto mr-4 ml-4">
        
        <label  for="inlineFormInput2">Calcola Ricarico </label>
               <div class="input-group mb-2">
                <div class="input-group-prepend">
                <div class="input-group-text perc">%</div>
                </div>
              <input  type="number" class="form-control " id="mult" placeholder="" v-model="multiplier">
              <button type="button" :disabled="!prices.price1 || !multiplier" @click="setCalc()"  title="Calcola ricarico"  class="btn calc pointer" id="basic-addon1"><i class="fas fa-calculator" aria-hidden="true"></i></button>
              <div class="input-group-text">

                  <span style="font-size: 15px;" class="badge badge-light">Ricarico {{markUp}}</span>

              </div>
            
              </div>
        
      </div> 
      <div class="col-auto ml-4">
        <label for="inputPrice2"><strong>PREZZO DI VENDITA</strong></label>
        <div class="input-group mb-2">
                <div class="input-group-prepend">
                <div class="input-group-text euro1">€</div>
                </div>  
                <input step="0.01" @input="setMarkUp()" required v-model="prices.price2"  class="form-control"   type="number" v-bind:placeholder="'Prezzo di vendita'">   
                
        </div>
        
        
    
      
     
    </div>   

</div>


<button @click="hasDifferentPrices=!hasDifferentPrices" type="button" class="btn btn-link mb-2 mt-2">{{hasDifferentPrices==true ? 'NASCONDI' : 'MOSTRA'}} TABELLA PREZZO PER MISURA</button>
<priceList v-show="hasDifferentPrices" ref="priceTable" v-bind:refresh="refresh"  v-bind:items="items"  @update="setPriceList" v-bind:sizes="localSizes" v-bind:costPrice="costPrice" v-bind:retailPrice="retailPrice" ></priceList>        

<!--<labelsTable  v-bind:productId="localProduct.productId"  v-bind:refresh="refresh" @update="setLabels" v-bind:sizes="localSizes" ></labelsTable>-->

<div class="modal-footer d-flex flex-column_">


  <!-- BOTTONI affiancati -->
  <div class="d-flex justify-content-end">
      <button v-if="false" @click="priceTable = true"
              type="button"
              class="btn btn-secondary mr-3">
        MOSTRA TABELLA PREZZO PER MISURA
      </button>

      <button type="submit" class="btn btn-primary text-right">
        <i class="far fa-save mr-3"></i>
        REGISTRA MOVIMENTO PRODOTTO
      </button>
  </div>

</div>
  
</form>
</div>

  <div v-if="false">
      <h5 v-if="true" class="mb-4">Dati JSON:</h5>
      <pre>{{ sizes }}</pre>       
  </div>

    </div>


</template>

<script>

import api                   from '@/api' 
import productInfo           from '@/components/product/ProductInfo.vue'
import priceList             from './PriceListTable.vue'
import { mapGetters }        from 'vuex'
import inputSconto           from '@/components/InputCustom/InputSconto.vue'
import modalMessage          from '@/components/modalDialog/ModalMessage.vue'
import modalConfirm          from '@/components/modalDialog/ModalConfirm.vue'
import documentHeader        from '@/components/backOffice/ready/DocumentHeader.vue'

//import labelsTable           from './LabelsTable.vue'

import { v4 as uuidv4 }      from 'uuid'


export default {
  
  components: {priceList,productInfo,priceList,inputSconto,modalMessage,modalConfirm,documentHeader},  
  props: ['sizes','product','variants','doc','counter','items','update'],
 
  data () {
  
    return {

     hasDifferentPrices : false,
     localProduct  : { ...this.product },
     localSizes    : this.sizes,
     prices        : {},    
     multiplier    : '',
     markUp        : 0.00,
     inputSconto   : [],     
     priceTable    : true,
     costPrice     : 0,
     retailPrice   : 0,
     priceList     : [], 
     msg           : '',
     spinner       : false,
     uuid          : '',
     refresh       : 0,
     btnBack       : true,
    // labels        : [],
    // refreshLabels : 0,
     pricesTable   : false
     
    
     
    

    }
  },
   directives: 
    {
      focus: {
      // directive definition
        inserted: function (el) {
  
          el.focus()
          el.select()
            
          }
       
      }
    },
  computed: 
    {     
     ...mapGetters(['company']) 
      
    },
          
  mounted()
    {
      this.refresh++

      /*
      if(this.items.prices)
      {
        this.$refs.priceTable.setPrices(this.items.prices) 
      }
      */
    },

  created()
  {
    
    this.uuid          = uuidv4()
    
    this.multiplier    = JSON.parse(localStorage.getItem("mult"))   
    this.prices.vat    = this.company.vat
    

    /*
    if(this.items.prices)
    {
      this.prices.price1 = this.items.prices[0].costPrice
      this.prices.price2 = this.items.prices[0].retailPrice      
      this.costPrice     = this.items.prices[0].costPrice
      this.retailPrice   = this.items.prices[0].retailPrice 
            
    }
     */ 
    
    let costPrice   = 0
    let retailPrice = 0
    
    if(this.items && this.items.prices)
    {

      const uniqueCostPrices   = [...new Set(this.items.prices.map(p => p.costPrice))]
      this.hasDifferentPrices = uniqueCostPrices.length > 1
      
  
      this.items.prices.forEach(item =>
        {
          if(item.costPrice)
          {
            costPrice   = item.costPrice
            retailPrice = item.retailPrice
          }
        }
      )
      this.prices.price1 = costPrice
      this.prices.price2 = retailPrice      
      this.costPrice     = costPrice
      this.retailPrice   = retailPrice 
        
    }



    if(this.items.discounts)
    { 
      this.inputSconto = this.items.discounts
    }

  },

  methods: 
  {
    /*
    setLabels(labels)
    {
      this.labels = labels
    },
    */
   add()
   {
    if(this.inputSconto.length < 3)
    {
      const l = this.inputSconto.length
      const obj = {'label' : l + 1 + '° sconto',discount : 0, id: l + 1 }
      this.inputSconto.push(obj)

      this.$nextTick(() => {
          const inputs = this.$refs.scontoInputs
          if (!inputs || !inputs.length) return

          const lastInput = inputs[inputs.length - 1]
          if (lastInput && lastInput.$el) {
            const inputEl = lastInput.$el.querySelector('input')
            if (inputEl) {
              inputEl.focus()   // mette il focus sull'input
              inputEl.select()  // seleziona tutto il valore
            }
          }
      })



    }
   
   }, 

   
  async saveProduct(items,sp) {
  
  
  try {

    
    /* =========================
       PREPARAZIONE DATI
    ========================== */

    const discounts = this.inputSconto
      .filter(s => s.discount != null && !isNaN(s.discount) && s.discount > 0)
      .map((s, index) => ({
        discount: Number(s.discount),
        order_by: index + 1
      }))

    
     //const labels  = this.labels  

    const payload = {
      productId       : this.localProduct.productId,    
      counter         : this.counter,
      items,
      
      companyId       : this.company.Id,
      storeId         : this.doc.storeId,
      stockMovementId : this.doc.stockMovementId,
      discounts,
      uuid            : this.uuid,

      sp             
     

    }
    
    // console.log('PAYLOAD',payload)

    //return
    this.btnBack = false

    /* =========================
       CHIAMATA API
    ========================== */
    
    this.$refs.msgModal.show()   
    this.$refs.msgModal.setSpinner(true)
    
    const res = await api.post(payload)

    if (res.status !== 200) 
    {
      throw new Error(res.data ||  res)
    }

    /* =========================
       CONTROLLO RISPOSTA UUID
    ========================== */

    

    this.$refs.msgModal.close()
    return true

    /* =========================
       SUCCESSO
    ========================== */
      

  }
  catch (err) {

    const msg = err.message + '\n' + 'RIPROVARE.'     
    await this.$refs.msgModal.show(msg,{},3)
    return false

  }
  finally {}

  

},

 async getToDoList() {
      
      const payload = 
      {
      
        companyId       : this.company.Id,      
        sp              : 'spToDoList'
      }
      
      try{

        const res = await api.post(payload)      
        if (res.status !== 200) {          
          throw new Error(res.data || res)          
        }      
        return res.data.recordsets
      }
        catch(err)
        {
          console.log(err)
          return []
        }    
    },


  getTableBase(barcodesData, pricesData) {
  
  const costPrices   = pricesData[0].prezzi;
  const retailPrices = pricesData[1].prezzi;
  
  const rows = [];

  barcodesData.forEach(item => {
    const colorId        = item.colorId;
    const supplierColor  = item.supplierColor;
    const quantities     = item.quantities;
    
    const barcodes       = item.barcodes;
    
    Object.keys(quantities).forEach(sizeId => {
      const key       = String(sizeId)
      const qty       = quantities[key]
      if(Number(qty))
      {
        rows.push({
          barcode       : barcodes[key],
          ean_13        : '',
          colorId       : colorId,
          supplierColor : supplierColor,
          qty           : quantities[key],    
          sizeId        : sizeId,
          costPrice     : costPrices[key],
          retailPrice   : retailPrices[key],
          vat           : this.prices.vat           
        })
      }
    })
  })

  return rows
},

getTableBaseUpdate(barcodesData, pricesData) {
  
  const costPrices   = pricesData[0].prezzi;
  const retailPrices = pricesData[1].prezzi;
  
  const rows = [];

  barcodesData.forEach(item => {
    const colorId        = item.colorId;
    const supplierColor  = item.supplierColor;
    const quantities     = item.quantities;
    const savedQty       = item.savedQty
    const barcodes       = item.barcodes;
    
    Object.keys(quantities).forEach(sizeId => {
      const key       = String(sizeId)
      const qty       = quantities[key]      
        if(Number(qty))
        {
        rows.push({
          barcode       : barcodes[key],
          ean_13        : '',
          colorId       : colorId,
          color         : supplierColor,
          qty           : qty,
          
          updateQty     : quantities[key] - (savedQty[key]),
          sizeId        : sizeId,
          costPrice     : costPrices[key],
          retailPrice   : retailPrices[key],
          vat           : this.prices.vat
                    
        })
      
        }
      
    })
  })
  
  return rows
},


    setPriceList(prices)
    { 
      // console.log('EMIT da FIGLIO',labels)     
      this.priceList = prices
      //this.labels    = labels
    },

    setCostPrice()
    {
      this.costPrice = this.prices.price1
      
    },

    async submit()
    {
        


        /* AGGIORNA ARRAY PREZZI */
        this.refresh++
       

        const type = this.update ? 'LA VARIAZIONE DEL' : ' IL NUOVO '
        const msg = 'SI DESIDERA REGISTRARE '  + type + ' MOVIMENTO PRODOTTO ?' 
        
        const confirmed = await this.$refs.confirmModal.show(
          msg,
          { title: 'CONFERMA' },1
        )

        if (!confirmed) return
         this.$refs.confirmModal.close()

        if(this.update)
        {
          const items = this.getTableBaseUpdate(this.variants, this.priceList)
          const res = await this.saveProduct(items,'spUpdateSupplierMovementProductRequestLog')
          if(!res) return

          if(this.company.shopify && process.env.NODE_ENV == 'production')
          {
            api.shopifyCreateProductVariants(this.company.Id,this.localProduct.productId)                                            
          }

          await this.$refs.msgModal.show('AGGIORNAMENTO ESEGUITO.',{'title':'MESSAGGIO'},4)
          this.$emit('update')
        }
        else
        {

        const items  = this.getTableBase(this.variants, this.priceList)
        
        const res = await this.saveProduct(items,'spInsertProductMovementRequestLog')
        if(!res) return
        
        
        if(this.company.shopify && process.env.NODE_ENV == 'production')
        {
          api.shopifyCreateProductVariants(this.company.Id,this.localProduct.productId)                                            
        }    
  



        const toDo = await this.getToDoList()        
        
        await this.$refs.msgModal.show('REGISTRAZIONE ESEGUITA.',{'title':'MESSAGGIO'},4)
        
        /* RITORNO A MAIN MODULE */
        this.$emit('update',toDo)

        }  



    },
    getDiscountedPrice()
    {
      
        let total = Number(this.prices.price1) || 0;
        for (const item of this.inputSconto) {
          // converte in number e verifica se è un valore valido > 0
          const d = Number(item.discount);
          if (!isNaN(d) && d > 0) {
            total -= (total * d) / 100;
          }
        }
        

        return total;


    },
    setCalc()
    {

      
      const total = this.getDiscountedPrice();
      
      const retailPrice = total + (total * this.multiplier) / 100
      
      this.prices.price2 = retailPrice.toFixed(2);
      localStorage.setItem('mult', JSON.stringify(this.multiplier));
      this.setMarkUp(total)
      
 },
 setMarkUp(price)
 {
  
  let price1 = !price ? this.getDiscountedPrice() : price
  
  this.markUp = 0
  if(Number(price1) > 0 && Number(this.prices.price2) > 0)
  {

    let n = Number(this.prices.price2) / Number(price1)
    this.markUp = n.toFixed(2)
  }

  this.retailPrice = this.prices.price2


 }
        
}
  
}
</script>

<style scoped>



.pointer{
  cursor: pointer;
}


h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
  
}
.euro{
  color             : white ;
  background-color  :  darkgreen;;
}

.calc{
  color: yellow;
  background-color:  #0787ff;;
}

.perc{
  color             : black;
  background-color:  rgb(236, 242, 233);;
}
.form-check-label{
  font-weight: bold;
  color: blueviolet;
}
.sconto{
  background-color: #ffc107;
  color: black;
}
.euro1{
  color            : white;
  background-color : #3f06a9;
}
</style>